import { render } from "./ReportContentModal.vue?vue&type=template&id=37ca4579"
import script from "./ReportContentModal.vue?vue&type=script&lang=js"
export * from "./ReportContentModal.vue?vue&type=script&lang=js"

import "./ReportContentModal.vue?vue&type=style&index=0&id=37ca4579&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__